import { createTypes } from "../../utils/helpers";


const EQUIPMENT_SPECIFIC_FETCH: any = createTypes('EQUIPMENT_SPECIFIC_FETCH');
const EQUIPMENT_SPECIFIC_UPDATE: any = createTypes('EQUIPMENT_SPECIFIC_UPDATE');
const EQUIPMENT_SPECIFIC_CREATE: any = createTypes('EQUIPMENT_SPECIFIC_CREATE');
const EQUIPMENT_SPECIFIC_EDIT: any = createTypes('EQUIPMENT_SPECIFIC_EDIT');
const EQUIPMENT_SPECIFIC_EDIT_SINGLE: any = createTypes('EQUIPMENT_SPECIFIC_EDIT_SINGLE');
const EQUIPMENT_SPECIFIC_DELETE: any = createTypes('EQUIPMENT_SPECIFIC_DELETE');

export {
    EQUIPMENT_SPECIFIC_FETCH,
    EQUIPMENT_SPECIFIC_UPDATE,
    EQUIPMENT_SPECIFIC_CREATE,
    EQUIPMENT_SPECIFIC_EDIT,
    EQUIPMENT_SPECIFIC_DELETE,
    EQUIPMENT_SPECIFIC_EDIT_SINGLE,
};
